export const campaignStates={draft:'Taslak',sending:'Gönderiliyor',sent:'Gönderildi',discarded:'Silindi'};
export const campaignError=e=>{
  const detail=e.response?.data?.detail;
  if(typeof detail==='string')return detail;
  if(Array.isArray(detail))return detail.map(v=>v.msg.replace(/^Value error, /,'')).join(' · ');
  return 'İşlem sonucu doğrulanamadı. Güncel bildirimi açıp tekrar deneyin.';
};